import React, { useEffect } from 'react'
import { Button, Group, Modal, Stack, TextInput, Textarea } from '@mantine/core'
import { useForm } from '@mantine/form'
import { DESCRIPTION_MAX_LENGTH } from './constants'

const GoalModal = ({ opened, onClose, onSubmit, initialValues, mode = 'create', isSaving = false }) => {
  const form = useForm({
    initialValues: initialValues || { name: '', description: '' },
    validate: {
      name: (v) => (v?.trim().length ? null : 'Goal name is required'),
    },
  })

  useEffect(() => {
    if (opened) {
      form.setValues(initialValues || { name: '', description: '' })
      form.resetDirty(initialValues || { name: '', description: '' })
    } else {
      form.reset()
    }
  }, [opened, initialValues])

  const title = mode === 'edit' ? 'Edit Goal' : 'Add Goal'
  const submitLabel = mode === 'edit' ? 'Save' : 'Add'

  return (
    <Modal opened={opened} onClose={onClose} title={title} centered>
      <form onSubmit={form.onSubmit((values) => onSubmit(values))}>
        <Stack spacing="md">
          <TextInput
            label="Goal name"
            placeholder="e.g. Netspend/Ouro"
            {...form.getInputProps('name')}
          />
          <Textarea
            label="Description"
            description="What this goal covers. The AI reads this when it tags meetings, so name the projects, products, or accounts it includes."
            placeholder="e.g. All migration work for the Netspend and Ouro card programs, including vendor calls."
            maxLength={DESCRIPTION_MAX_LENGTH}
            autosize
            minRows={3}
            maxRows={6}
            {...form.getInputProps('description')}
          />
          <Group position="right" mt="sm">
            <Button variant="default" onClick={onClose} type="button">
              Cancel
            </Button>
            <Button type="submit" loading={isSaving}>
              {submitLabel}
            </Button>
          </Group>
        </Stack>
      </form>
    </Modal>
  )
}

export default GoalModal
